import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors, { addon_pro_em_devices } from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import plugs_app_settings from '@devices/settings/device_settings/plugs_app_settings.js';
import share from '@devices/settings/device_settings/share.js';
import emeter_monophase_settings_gen_2 from '@devices/settings/device_settings/emeter_monophase_settings_gen_2.js';
import emeter_pro_triphase_settings_gen_2 from '@devices/settings/common_settings/emeter_pro_triphase_settings_gen_2';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPro3EM2000',
	friendly_name: 'Pro 3EM 2000',
	family: 'emeter',
	isPM: true,
	addons: addon_pro_em_devices,
	modes: {
		monophase: {
			channels: 3,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage'],
			phases: 3,
			settings: [
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components_pro_devices,
				networks_gen_2_pro,
				bluetooth_gen_2,
				plugs_app_settings,
				share,
				emeter_monophase_settings_gen_2,
			],
		},
		triphase: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage'],
			phases: 3,
			settings: emeter_pro_triphase_settings_gen_2,
		},
	},
};
